import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConnectedRouter } from "react-router-redux";
import { history, store, persistor } from "./store";
import App from "./routes/app";

import "./index.scss";
import "./index.css";

const target = document.querySelector("#root");

require("dotenv").config();

render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  target
);



// WEBPACK FOOTER //
// ./src/index.js